module.exports = __webpack_public_path__ + "img/A1-3-plan.90f2189e.png";